import { render, staticRenderFns } from "./expense-scac-info.vue?vue&type=template&id=540a2ca0&"
import script from "./expense-scac-info.vue?vue&type=script&lang=js&"
export * from "./expense-scac-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports